export default "__VITE_ASSET__u$9KAOcu__"